import React from "react";
import { Layout, Menu, Icon } from "antd";
import { menuByRouteName } from "../../router";

const { Header } = Layout;

export default (props) => {
  const { logOut, handleClick } = props;

  const handleMenuClick = ({ key }) => {
    if (key === "signout") {
      logOut();
    } else {
      handleClick({ key });
    }
  };
  return (
    <div className="header-wrapper">
      <Header>
        <Menu
          theme="light"
          mode="horizontal"
          onClick={handleMenuClick}
          style={{ float: "right" }}
        >
          {menuByRouteName("UserSetting")}
          <Menu.Item key="signout">
            <Icon type="logout" />
            <span>登出</span>
          </Menu.Item>
        </Menu>
      </Header>
    </div>
  );
};
